import React from "react";
import { motion } from "framer-motion";
import { f } from '../../../../_f';

export default class TutorialOverlayStart extends React.Component {
    constructor( props ) {
        super(props);

    }

    get pointerString() {
        return f.isTouchDevice ? 'tippen' : 'klicken';
    }

    render() {
        return (
            <div className="tutorial-area  tutorial-area__start">
                <div className="instruction-info  [ wow fadeInUp ]  [ margin__bottom--small ]">
                    <div className="instruction-info__text  margin__bottom--xsmall">
                        Hier {this.pointerString} für mehr Infos!
                    </div>

                    <motion.div
                        className="flex-col  align-middle"
                        animate={{
                            // rotate: 180,
                            y: 5
                        }}
                        transition={{
                            type:       "spring",
                            stiffness:  100,
                            repeat:     Infinity,
                            repeatType: "reverse"
                        }}>

                        <div className="instruction-info__icon  relative">
                            <svg viewBox="0 0 20 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g fill="currentColor">
                                    <path
                                        d="M17.6743 16.1139C17.0692 16.0183 16.5278 16.2731 16.1457 16.6871C15.9546 15.9228 15.2859 15.3496 14.4579 15.3496C13.9165 15.3496 13.4388 15.6043 13.1204 15.9865C12.8974 15.2859 12.2287 14.7764 11.4644 14.7764C10.9867 14.7764 10.5409 14.9674 10.2224 15.2859L10.2224 8.69383C10.2224 7.80216 9.58551 7.00602 8.72568 6.91049C7.67478 6.7831 6.75125 7.61108 6.75125 8.63014L6.75125 20.3812C6.75125 20.6041 6.4328 20.6996 6.30542 20.5086L4.2673 17.4514C3.78961 16.7189 2.73871 16.5597 1.94257 17.1011C1.14643 17.6424 0.859814 18.6615 1.3375 19.3621C1.3375 19.3621 7.00602 27.9286 7.03787 27.9923C8.05692 29.4253 9.74474 30.2851 11.5599 30.2851L13.5662 30.2851C16.5915 30.2851 19.1073 27.8649 19.1392 24.8077C19.1392 24.7759 19.1392 24.744 19.1392 24.6803L19.1392 17.9291C19.171 17.0055 18.5341 16.2094 17.6743 16.1139Z"/>
                                    <path
                                        d="M8.47094 4.42654C8.88493 4.42654 9.23524 4.07623 9.23524 3.66224L9.23524 0.764295C9.23524 0.350302 8.88493 -7.42337e-06 8.47094 -7.49576e-06C8.05694 -7.56814e-06 7.70663 0.350302 7.70663 0.764294L7.70663 3.66224C7.70663 4.07623 8.05694 4.42654 8.47094 4.42654Z"/>
                                    <path
                                        d="M4.52208 5.60481C4.6813 5.76404 4.87238 5.82773 5.06345 5.82773C5.25453 5.82773 5.44561 5.76404 5.60483 5.60481C5.89144 5.3182 5.89144 4.80868 5.60483 4.52207L3.56671 2.48394C3.2801 2.19733 2.77058 2.19733 2.48397 2.48394C2.19736 2.77055 2.19736 3.28009 2.48397 3.5667L4.52208 5.60481Z"/>
                                    <path
                                        d="M4.42653 8.47091C4.42653 8.05692 4.07624 7.70663 3.66224 7.70663L0.764283 7.70663C0.35029 7.70663 -6.12466e-08 8.05692 -1.33631e-07 8.47091C-2.06016e-07 8.8849 0.35029 9.23521 0.764282 9.23521L3.66224 9.23521C4.07624 9.23521 4.42653 8.8849 4.42653 8.47091Z"/>
                                    <path
                                        d="M12.5153 8.47091C12.5153 8.88491 12.8656 9.23522 13.2796 9.23522L16.1775 9.23522C16.5915 9.23522 16.9418 8.88491 16.9418 8.47091C16.9418 8.05692 16.5915 7.70663 16.1775 7.70663L13.2796 7.70663C12.8656 7.70663 12.5153 8.05692 12.5153 8.47091Z"/>
                                    <path
                                        d="M11.8784 5.82773C12.0695 5.82773 12.2606 5.76404 12.4198 5.60481L14.4579 3.5667C14.7445 3.28009 14.7445 2.77055 14.4579 2.48394C14.1713 2.19733 13.6618 2.19733 13.3752 2.48394L11.337 4.52207C11.0504 4.80868 11.0504 5.3182 11.337 5.60481C11.4644 5.76404 11.6873 5.82773 11.8784 5.82773Z"/>
                                </g>
                            </svg>
                        </div>

                        <div className="instruction-info__arrow">
                            <svg viewBox="0 0 14 69" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M7.17157 0.285149C7.72385 0.285149 8.17157 0.732864 8.17157 1.28515L8.17157 65.1716L12.0502 61.2929C12.4408 60.9024 13.0739 60.9024 13.4645 61.2929C13.855 61.6834 13.855 62.3166 13.4645 62.7071L7.87867 68.2929C7.48815 68.6834 6.85499 68.6834 6.46446 68.2929C6.43542 68.2638 6.40855 68.2335 6.38383 68.202C6.35231 68.1772 6.32193 68.1504 6.29289 68.1213L0.707108 62.5355C0.316584 62.145 0.316584 61.5118 0.707108 61.1213C1.09763 60.7308 1.7308 60.7308 2.12132 61.1213L6.17157 65.1716L6.17157 1.28515C6.17157 0.732864 6.61929 0.285149 7.17157 0.285149Z"
                                      fill="currentColor"/>
                            </svg>
                        </div>
                    </motion.div>

                </div>
            </div>
        );
    }

}
